export default __webpack_public_path__ + "static/media/Mark-2-HUD-Label (Warning).d11053c3.jpg";